/*
 * Copyright © 2015-2022 Serenova, LLC. All rights reserved.
 */

/*
 * InviteAccept Messages
 *
 * This contains all the text for the InviteAccept component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  changePassword: {
    id: 'invite.accept.changePassword',
    defaultMessage: 'Change Password',
  },
  confirmPassword: {
    id: 'invite.accept.confirmPassword',
    defaultMessage: 'Confirm Password',
  },
  existingFail: {
    id: 'invite.accept.existing.fail',
    defaultMessage: 'Sorry, your invitation could not be accepted.',
  },
  firstName: {
    id: 'invite.accept.firstName',
    defaultMessage: 'Please enter a first name'
  },
  lastName: {
    id: 'invite.accept.lastName',
    defaultMessage: 'Please enter a last name'
  },
  loadingSdk: {
    id: 'login.loadingSdk',
    defaultMessage: 'Loading the SKD',
  },
  missingPassword: {
    id: 'invite.accept.missingPassword',
    defaultMessage: 'Please enter a password in both fields.',
  },
  mixMatch: {
    id: 'invite.accept.mixMatch',
    defaultMessage: 'The password(s) entered do not match.',
  },
  newPassword: {
    id: 'invite.accept.newPassword',
    defaultMessage: 'New Password',
  },
  passwordLength: {
    id: 'invite.accept.passwordLength',
    defaultMessage: 'Must be at least 8 characters in length',
  },
  passwordPolicyText: {
    id: 'invite.accept.passwordPolicyText',
    defaultMessage:
      'Password must have at least 1 alphabetic character, 1 number, and 1 special character (! # $ % - _ = + < > .)',
  },
  submitError: {
    id: 'invite.accept.submitError',
    defaultMessage: 'Submit Failed'
  },
  submitSuccess: {
    id: 'invite.accept.submitSuccess',
    defaultMessage: 'Submit Success'
  },
  submitUserAcceptedStatusError: {
    id: 'invite.accept.submitUserAcceptedStatusError',
    defaultMessage: 'User Account Update Failed'
  },
  submitUserAcceptedStatusSuccess: {
    id: 'invite.accept.submitUserAcceptedStatusSuccess',
    defaultMessage: 'User Account Updated'
  },
  submitUserAccount: {
    id: 'invite.accept.submitUserAccount',
    defaultMessage: 'Submit'
  },
  success: {
    id: 'invite.accept.success',
    defaultMessage: 'Your invitation has been accepted!'
  },
});
